module.exports = __webpack_public_path__ + "img/ic_qr_code.8f1187ad.svg";